define.alias("ember-truth-helpers/helpers/is-equal", "media/helpers/is-equal");